import deepDefaults from './deepDefaults'
import defaultJDISettings from './defaultJDISettings'

const parseText = data => {

  var lines = data.split('\n');

  var pattern = {
    units: 'INCH',
    type: 'DRAFTING',
    mode: 'raster',
    rows: []
  }

  let name_line;

  let line_segment_data_string = "";
  let jdi_settings_data_string = "";

  for(var i in lines){
    if(lines[i].indexOf('*') === 0){
      pattern.name = lines[i].substring(1,lines[i].length).trim();
      name_line = parseInt(i);
      continue;
    }
    if(lines[i].indexOf(';%VERSION=3.0') === 0){
      pattern.format = 'REVIT';
      continue;
    }
    if(lines[i].indexOf(';%UNITS=') === 0){
      pattern.units = lines[i].substring(8,lines[i].length).trim();
      pattern.format = 'REVIT';
      continue;
    }
    if(lines[i].indexOf(';%TYPE=') === 0){
      pattern.type = lines[i].substring(7,lines[i].length).trim();
      pattern.format = 'REVIT';
      continue;
    }

    if(lines[i].indexOf('; PATTYCAKE_TEMPLATE=') === 0){
      pattern.calculator = window.atob(lines[i].replace('; PATTYCAKE_TEMPLATE=',''));
      pattern.mode = 'template';
      continue;
    }
    if(lines[i].indexOf('; PATTYCAKE_TEMPLATE_VARIABLES=') === 0){
      try{
        pattern.variables = JSON.parse(window.atob(lines[i].replace('; PATTYCAKE_TEMPLATE_VARIABLES=','')));
        pattern.mode = 'template';
      } catch(e){
        console.error("JSON parse of variable data failed");
      }
      continue;
    }

    if(lines[i].indexOf('; PATTYCAKE_DRAWING_CANVAS_WIDTH=') === 0){
      pattern.width = parseFloat(lines[i].replace('; PATTYCAKE_DRAWING_CANVAS_WIDTH=',''));
      continue;
    }
    if(lines[i].indexOf('; PATTYCAKE_DRAWING_CANVAS_HEIGHT=') === 0){
      pattern.height = parseFloat(lines[i].replace('; PATTYCAKE_DRAWING_CANVAS_HEIGHT=',''));
      continue;
    }
    if(lines[i].indexOf('; PATTYCAKE_DRAWING_CANVAS_LINESEGMENTS=') === 0){
      line_segment_data_string += lines[i].replace('; PATTYCAKE_DRAWING_CANVAS_LINESEGMENTS=','').trim();
      continue;
    }
    if(lines[i].indexOf('; PATTYCAKE_DRAWING_CANVAS_SETTINGS=') === 0){
      jdi_settings_data_string = lines[i].replace('; PATTYCAKE_DRAWING_CANVAS_SETTINGS=','').trim();
      continue;
    }

    if(lines[i].indexOf(';') === 0){
      if(name_line + 1 === parseInt(i)){
        pattern.description = lines[i].substring(1,lines[i].length).trim();
      }
      continue;
    }
    var pieces = lines[i].split(/,\s*/g);
    if(pieces.length >= 5){
      for(var j in pieces){
        pieces[j] = parseFloat(pieces[j]);
      }
      pattern.rows.push({
        original_index: pattern.rows.length,
        cells: pieces
      });
    }
  }

  try{

    if(line_segment_data_string !== ""){
      pattern.lineSegments = JSON.parse(window.atob(line_segment_data_string));
      pattern.jdiSettings = {};

      let legacy = true;
      if(jdi_settings_data_string !== ""){
        pattern.jdiSettings = JSON.parse(window.atob(jdi_settings_data_string));
        legacy = false;
      }

      // backwards compatible
      if(pattern.width) pattern.jdiSettings.canvas_width = pattern.width;
      if(pattern.height) pattern.jdiSettings.canvas_height = pattern.height;

      pattern.jdiSettings = deepDefaults(pattern.jdiSettings, defaultJDISettings);

      var mindim = Math.min(pattern.jdiSettings.canvas_width, pattern.jdiSettings.canvas_height);

      if(legacy){
        if(pattern.units === 'INCH') pattern.jdiSettings.grid_snap_size = .125;
        if(pattern.units === 'MM') pattern.jdiSettings.grid_snap_size = mindim / 10;
      }

      pattern.mode = 'drawing';
      console.log("DETECTED DRAWING", line_segment_data_string)
    }
  } catch(e){
    console.error("JSON parse of drawing canvas data failed");
  }

  pattern.units = pattern.units.toUpperCase();
  pattern.type = pattern.type.toUpperCase();

  if(pattern.units !== 'INCH' && pattern.units !== 'MM'){
    pattern.units = 'INCH';
  }

  if(pattern.type !== 'DRAFTING' && pattern.type !== 'MODEL'){
    pattern.type = 'DRAFTING';
  }
  
  pattern.text = data;

  return pattern;
}

export default parseText;


// WEBPACK FOOTER //
// ./src/pattern_utilities/parseText.js